import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
import Typography from '../Typography';
var Label = styled.label.withConfig({
  displayName: "ui-kit-Label",
  componentId: "ui-kit-oyf6fh"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n\n  &.placementLeft {\n    flex-direction: row-reverse;\n    text-align: right;\n  }\n  &.disabled {\n    cursor: default;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n\n  &.placementLeft {\n    flex-direction: row-reverse;\n    text-align: right;\n  }\n  &.disabled {\n    cursor: default;\n  }\n"])));
export var mapPlacement = function mapPlacement(placement) {
  return "placement".concat(capitalize(placement));
};
var FieldLabel = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      label = _a.label,
      placement = _a.placement,
      children = _a.children,
      disabled = _a.disabled,
      disableTypography = _a.disableTypography,
      typographyProps = _a.typographyProps,
      props = __rest(_a, ["className", "label", "placement", "children", "disabled", "disableTypography", "typographyProps"]);

  var combinedClassName = classnames(className, placement && mapPlacement(placement), {
    disabled: disabled
  });
  return _jsxs(Label, __assign({
    className: combinedClassName,
    ref: ref
  }, props, {
    children: [children, disableTypography ? label : _jsx(Typography, __assign({
      as: "span",
      color: disabled ? 'disabled' : undefined,
      variant: "body14"
    }, typographyProps, {
      children: label
    }))]
  }));
});
export default FieldLabel;
var templateObject_1;